import { render, staticRenderFns } from "./SnapFormWizardSmall.vue?vue&type=template&id=73bd6465"
import script from "./SnapFormWizardSmall.vue?vue&type=script&lang=js"
export * from "./SnapFormWizardSmall.vue?vue&type=script&lang=js"
import style0 from "./SnapFormWizardSmall.vue?vue&type=style&index=0&id=73bd6465&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports